<!-- themeLogo -->
<section style="margin: 0; padding: 0;" class="sticky" [ngClass]="class" [class.fixed]="stick && sticky">
  <div *ngIf="!hostBarEnable" style="background: var(--primary-color) !important; position: sticky;top: 0;">
    <div class="col-lg-12">
      <div style="text-align: center;">
        <ul>
          <li style="color: #fff;">{{host}}</li>
          <li>
          </li>
        </ul>
      </div>
    </div>

  </div>
</section>
<section style="margin: 0; padding: 0;" class="sticky" [ngClass]="class" [class.fixed]="stick && sticky">
  <div *ngIf="hostBarEnable" style="background: rgb(196,28,34);
background: linear-gradient(40deg, rgba(196,28,34,1) 0%, rgba(0,0,0,1) 100%); position: sticky;top: 0;">
    <div class="col-lg-12">
      <div style="text-align: center;">
        <ul>
          <li style="color: #fff;">{{host}}</li>
          <li>
          </li>
        </ul>
      </div>
    </div>

  </div>
</section>
<header class="sticky" [ngClass]="class" [class.fixed]="stick && sticky">
  <div class="mobile-fix-option">
</div>
  <div class="top-header" *ngIf="topbar">
    <div class="container">

      <div class="row">
        <div class="col-lg-6">
          <!-- <div class="header-contact">
            <ul>
               <li>Welcome to WhiteRobe</li>
              {{companyName}}
              <li *ngIf="companyName; else defaultMessage">Welcome to {{ companyTitle }}</li>
              <ng-template #defaultMessage>
                <li>Welcome to WhiteRobe</li>
              </ng-template>

              <li *ngIf="!isLoggedIn">
                <i class="fa fa-phone" aria-hidden="true"></i>Call Us:
                <a class="phone-number" href="tel:+917075855784">+91-70 75 85 5784</a>
              </li>
            </ul>
          </div> -->
        </div>
        <div class="col-lg-5 text-end">
          <ul class="header-dropdown">
            <li *ngIf="!isLoggedIn" class="compare">
              <a (click)="goTo('/sign-in')" matTooltip="For vendors only">Post free jobs</a>
              <!-- <i class="fa fa-user-plus" aria-hidden="true"></i> -->
            </li>
            <!-- <li *ngIf="!isLoggedIn" class="mobile-wishlist">
              <a (click)="goTo('/login')" matTooltip="For vendors only"><i class="fa fa-sign-in"
                  aria-hidden="true"></i>Login</a>
            </li> -->
            <li *ngIf="!isLoggedIn" class="mobile-wishlist"></li>
            <li *ngIf="isLoggedIn" class="onhover-dropdown mobile-account">
              <i class="fa fa-user" aria-hidden="true"></i> My Account
              <ul class="onhover-show-div">
                @for (menu of myAcountMenu; track menu; let i = $index) {
                <li (click)="goTo(menu.link)">
                  <a data-lng="en">
                    <span [innerHTML]="menu.icon"></span>
                    {{menu.title}}
                  </a>
                </li>
                }
                <!-- <li>
                  <a data-lng="en" (click)="goTo('/vendor/vendor-porfile')">
                    <i class="fa fa-user" aria-hidden="true"></i>
                    My Profile
                  </a>
                </li>
                <li>
                  <a data-lng="en" (click)="goTo('/vendor/')">
                    <i class="fa fa-id-card-o" aria-hidden="true"></i>
                    Dashboard
                  </a>
                </li>  -->

                <li>
                  <a data-lng="es" (click)="logout()" style="color:var(--primary-color)">
                    <i class="fa fa-sign-out" aria-hidden="true"></i>
                    Logout
                  </a>
                </li>
              </ul>
            </li>
            &nbsp;
            <li *ngIf="isLoggedIn">
              <i [ngClass]="fullScreenDisplay ? 'fa fa-arrows-alt' : 'fa fa-desktop'"   aria-hidden="true" (click)="setFullScreen()"></i>
            </li>
          </ul>
          
          <!-- <ul class="header-dropdown">
            <li class="compare">
              <a [routerLink]="['/vendor/register']"><i class="fa fa-random" aria-hidden="true"></i>Register</a>
            </li>
            <li class="mobile-wishlist">
              <a [routerLink]="['/admin/login']"><i class="fa fa-heart" aria-hidden="true"></i>Login</a>
            </li>
            <li class="onhover-dropdown1 mobile-account">
              <a [routerLink]="['/admin/login']"><i class="far fa-user-circle" style="--fa-primary-color: $theme-deafult; --fa-secondary-color: #ecb3ac;"></i>
                </a>
              
              <ul class="onhover-show-div">
                <li>
                  <a data-lng="en" [routerLink]="['/admin/login']"> Login </a>
                </li>
                <li>
                  <a [routerLink]="['/vendor/vendor-porfile']" data-lng="es"> My Account </a>
                </li>
                <li>
                  <a [routerLink]="['/vendor/']" data-lng="es"> Dashboard </a>
                </li>
                <li>
                  <a [routerLink]="['/']" data-lng="es"> Logout </a>
                </li>
              </ul>
            </li>
             <li  *ngIf="!isLoggedIn">
              <a style="color:var(--primary-color)" [routerLink]="['/vendor/register']"> Register</a>/
            <a style="color:var(--primary-color)" [routerLink]="['/login']"> Login</a>
             </li>
            
            <li class="onhover-dropdown1 mobile-account" *ngIf="isLoggedIn">
              <a (click)="logout()" style="color:var(--primary-color)"> Logout</a>
            </li>
          </ul> -->
        </div>
        <!-- <div class="col-lg-1">
          <img [src]="left_menu_display ? '/assets/images/icon/full-screen.svg' : '/assets/images/icon/exix-f.svg'"
            class="text-end" (click)="setFullScreen()" [title]="left_menu_display ? 'Full Screen ' : 'Exit Full Screen'"
            height="22px" />
        </div> -->

      </div>

    </div>
  </div>
  <!-- <div class="container" style="height: 5.5rem;">
    <div class="">
      <div class="">
        <div class="main-menu">
          <div class="menu-left">
            <app-left-menu></app-left-menu>
            <div class="brand-logo">
              <a id="headerlogo">
              <img [src]="logo" (error)="logo = 'assets/images/logos/final-logo.png'" (click)="goToDashboard()" class="img-fluid"
                [ngClass]="{
                  'default-logo': isDefaultLogo,
                  'custom-logo': !isDefaultLogo
                }" alt="logo" />




                <img [src]="logo || 'assets/images/logos/final-logo.png'"
   (click)="goTo('/vendor')"
  class="img-fluid"
  alt="logo"
                  style="width:5rem; height: 5rem; cursor: pointer;border-radius: 100%;" />

                <img [src]="logo" (click)="goTo('/')" class="img-fluid" alt="logo" style="width: 12.5rem; height: 8rem; cursor: pointer;"  />
                <span style="
    color: var(--primary-color);
    font-size: 2rem;
    font-weight: normal;
">WHITE ROBE</span>
              </a>
            </div>
          </div>
          <div class="menu-right pull-right">
            <div>
              <app-menu></app-menu>
            </div>
            <div>
              <app-settings></app-settings>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div> -->
</header>